import { render, staticRenderFns } from "./DtDayStudent.vue?vue&type=template&id=a8dba086&"
import script from "./DtDayStudent.vue?vue&type=script&lang=js&"
export * from "./DtDayStudent.vue?vue&type=script&lang=js&"
import style0 from "./DtDayStudent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports